export const SET_DOCUMENT_PROCESSORS = "SET_DOCUMENT_PROCESSORS";
export const SET_IS_LOADING = "SET_IS_LOADING";
